import { render } from "./dpp-suggestion.vue?vue&type=template&id=4dddc714"
import script from "./dpp-suggestion.js?vue&type=script&lang=js"
export * from "./dpp-suggestion.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__